import React, { useState, useEffect, useRef } from 'react';
import styles from './ScrollContainer.module.scss';
import ScrollMenuArrow from '../ScrollMenuArrow/ScrollMenuArrow';
import useWindowSize from '../../../common/hooks/useWindowSize';
import cx from 'classnames';

const SCROLL_SHIFT = 75;

const ScrollContainer = ({
  children,
  setMouseInScrollSlider = () => {},
  mouseLeaveScrollContainer = () => {},
  vertical = false,
  className,
  innerStyles = {},
  innerRef,
  innerRefListenerCallback,
}) => {
  const [scrollBackVisible, setscrollBackVisible] = useState(false);
  const [scrollForwardVisible, setscrollForwardVisible] = useState(false);
  const size = useWindowSize();
  const [init, setInit] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      updateBoundaries();
    }, 100);
  }, []);

  useEffect(() => {
    !init && updateBoundaries();
  }, [size]);

  useEffect(() => {
    updateBoundaries();
  }, [children]);

  const moveForward = () => {
    innerRef.current.scrollTo({
      left: innerRef.current.scrollLeft + SCROLL_SHIFT,
      behavior: 'smooth',
    });
    updateBoundaries();
  };

  const moveBack = () => {
    innerRef.current.scrollTo({
      left: innerRef.current.scrollLeft - SCROLL_SHIFT,
      behavior: 'smooth',
    });
    updateBoundaries();
  };

  const toggleMouseEnterContainer = () => {
    setMouseInScrollSlider(true);
  };

  const toggleMouseLeaveContainer = () => {
    setMouseInScrollSlider(false);
    mouseLeaveScrollContainer();
  };

  const updateBoundaries = () => {
    if (innerRef?.current != null) {
      const { scrollWidth, scrollLeft, offsetWidth, children } = innerRef.current;
      const scrollDifference = Math.floor(scrollWidth - scrollLeft);

      setscrollBackVisible(Math.floor(scrollLeft) !== 0);
      if (init) {
        if (!children?.length) {
          return;
        }

        const childrenArray = Array.from(children);
        const childrenLength = childrenArray.map(item => item.offsetWidth).reduce((prevValue, nextValue) => prevValue + nextValue);
        if (childrenLength > offsetWidth) {
          setscrollForwardVisible(true);
        }
        setInit(false);
      } else {
        setscrollForwardVisible(scrollDifference > offsetWidth);
      }
    }
  };

  useEffect(() => {
    innerRefListenerCallback && innerRefListenerCallback(innerRef?.current?.offsetHeight);
  }, [innerRef?.current?.offsetHeight]);

  return (
    <div
      ref={innerRef}
      onScroll={updateBoundaries}
      className={cx(styles.scrollContainer, className, {
        [styles.scrollIsVisible]: (scrollForwardVisible || scrollBackVisible) && !vertical,
      })}
      onMouseLeave={toggleMouseLeaveContainer}
      onMouseOver={toggleMouseEnterContainer}
      style={innerStyles}
    >
      {!vertical && <ScrollMenuArrow onClick={moveBack} disabled={!scrollBackVisible} />}
      {children}
      {!vertical && <ScrollMenuArrow type={'RIGHT'} onClick={moveForward} disabled={!scrollForwardVisible} />}
    </div>
  );
};

export default ScrollContainer;
